<template>
  <BaseDialogForm
    v-model="showSubscriptionRenewForm"
    :title="`Renew ${subscriptionModule.subscription} of ${companyObject.name}`"
    maxWidth="40vw"
    :nonFieldErrors="formErrors.non_field_errors"
  >
    <template #content>
      <v-form v-model="isValid" ref="companyConfig">
        <v-row class="ma-0">
          <v-col>
            <SelectField
              id="subscription"
              name="subscription"
              v-model="companyConfig.subscription"
              :label="`Select ${subscriptionModule.subscription}*`"
              :itemsList="subscriptionList"
              :rules="[
                (val) =>
                  !!val || `${subscriptionModule.subscription} is required`,
              ]"
              hide-details="auto"
              item-text="name"
              item-value="id"
              :error-messages="formErrors.subscription"
              @input="delete formErrors.subscription"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #actions>
      <v-btn
        id="subscriptionSubmit"
        color="primary"
        depressed
        @click="submitForm()"
        :disabled="!isValid"
      >
        Submit
      </v-btn>
    </template>
  </BaseDialogForm>
</template>

<script>
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import { bus } from "@/main";
import { subscriptionModule } from "@/utils/moduleMapping";

export default {
  components: {
    BaseDialogForm,
  },
  emits: ["reloadWindow"],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    companyObject: {
      type: [Object],
    },
  },
  computed: {
    showSubscriptionRenewForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      subscriptionModule,
      formErrors: {},
      companyConfig: {},
      isValid: true,
      subscriptionList: [],
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.getSubscriptionList();
      } else {
        this.formErrors = {};
        this.companyConfig = {};
        this.$refs.companyConfig.resetValidation();
      }
    },
  },

  methods: {
    submitForm() {
      bus.$emit("showLoader", true);
      this.$api.company
        .renewSubscription(this.companyObject.id, {
          ...this.companyConfig,
        })
        .then(() => {
          this.showSubscriptionRenewForm = false;
          this.$emit("reloadWindow");
          bus.$emit("showToastMessage", {
            message: "Subscription details updated!",
            color: "success",
          });
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.formErrors = err.data;
          bus.$emit("showLoader", false);
        });
    },
    async getSubscriptionList() {
      bus.$emit("showLoader", true);
      await this.$api.subscription
        .getSubscriptionList({ limit: "all" })
        .then((res) => {
          this.subscriptionList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style></style>
